import { AIAgentAnalyticsItemModel } from "@jugl-web/rest-api/integrations/models/AIAgentAnalyticsItem/AIAgentAnalyticsItemModel";
import { useMemo } from "react";
import type { ImpactDistributionDataEntry } from "../components/ImpactDistributionWidget";
import { getBaseColorByIndex } from "../utils";

interface UseImpactDistributionWidgetDataOptions {
  analyticsData: AIAgentAnalyticsItemModel[];
}

export const useImpactDistributionWidgetData = ({
  analyticsData,
}: UseImpactDistributionWidgetDataOptions) => {
  return useMemo(() => {
    const countsByImpact = analyticsData.reduce<Record<string, number>>(
      (acc, item) => {
        acc[item.businessImpact] = (acc[item.businessImpact] ?? 0) + 1;
        return acc;
      },
      {}
    );

    const totalChatsCount = analyticsData.length;

    const sortedEntries = Object.entries(countsByImpact).sort(
      (a, b) => b[1] - a[1]
    );

    const impactDetailsById: Record<string, ImpactDistributionDataEntry> = {};
    const impactDistributionData: ImpactDistributionDataEntry[] = [];

    sortedEntries.forEach(([impactType, count], index) => {
      const percentage =
        totalChatsCount > 0 ? Math.round((count / totalChatsCount) * 100) : 0;

      const color = getBaseColorByIndex(index);

      impactDetailsById[impactType] = {
        impactType,
        chatsCount: count,
        percentage,
        color,
      };

      impactDistributionData.push({
        impactType,
        chatsCount: count,
        percentage,
        color,
      });
    });

    return { impactDetailsById, impactDistributionData };
  }, [analyticsData]);
};
